import React from "react";
import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
export default function SearchBar({ text, setText }) {
  return (
    <div
      style={{
        backgroundColor: "#fff",
        width: "fit-content",
        padding: "5px",
        margin: "10px",
      }}
    >
      <TextField
        id="input-with-icon-textfield"
        placeholder="Search..."
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        value={text}
        onChange={(e) => setText(e.target.value)}
        variant="outlined"
      />
    </div>
  );
}
